import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { Row, Spin } from "antd";
import StockHome from "./Pages/StockHome";

const HomePage = () => {
  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
    isAdmin: false,
    defaultModuleId: null,
  });

  const [userDefaultSelectableModules, setUserDefaultSelectableModules] =
    useState({
      data: [],
      loading: true,
    });

  useEffect(() => {
    getModules();
    getUserPermissions();
  }, []);

  const getModules = () => {
    RequestHandler.get("/Module/GetDefaultSelectableModules").then(
      (response) => {
        setUserDefaultSelectableModules({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getUserPermissions = () => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
      localStorage.setItem("defaultModuleId", response.defaultModuleId);
    });
  };

  const RenderModulePage = () => {
    const homePages = {
      14: <StockHome />,
    };


    //default module yoksa
    if (permissions.modules.includes(14)) {
      return homePages[14];
    
    } else {
      window.location = "/not-authorized-access";
      return null;
    }
  };

  return permissions.loading || userDefaultSelectableModules.loading ? (
    <Row align="middle" justify="center" style={{ height: "100%" }}>
      <Spin spinning={true} />
    </Row>
  ) : (
    RenderModulePage()
  );
};
export default HomePage;
